import React from 'react';
import { Grid, Image } from 'semantic-ui-react';
import Media from 'react-media';
import { Link } from 'gatsby';

import BasicSectionLayout from './SectionLayout';
import SectionHeaderLayout from './SectionHeaderLayout';


import roundedimage1 from '../myImages/roundedImages/fipi_work.jpeg';
import roundedimage2 from '../myImages/roundedImages/together.jpeg';

const ThirdSection = () => {
  return (
    <BasicSectionLayout sectionClasse="descriptionSection" fluide={true}>
        <Grid.Column computer={10} tablet={14} mobile={16} textAlign="justified">

          <SectionHeaderLayout myhr={true}
            align ="center"
            headerclass="desciptionTitle bigTitle"
            title="Description"
            text="interview__text padded__text"            
          >
            <p className="paragraph padded__text">
              Created in 2015 by a group of former classmates, <strong>FIPI</strong> (Future Engineers and Computer Programming) is 
              an unregistered non-profit association which brings together engineers, students, teachers, technicians 
              and whose activities are based in Cameroon.<br/>
              In a world that wants to be more and more digital, a good mastery of new information and communication 
              technologies (ICT), is one of the efficient solutions to ensure and / or guarantee a reliable and <strong>sustainable development</strong>.<br/>
              To this end, the objective of <strong>FIPI</strong> is first of all to popularize information and communication technologies through simple, 
              innovative solutions and above all accessible to all. And also to show young people how to develop solutions adapted to 
              their environment while being an actor of development... <Link className="lire__suite lire__suite-dark" to="/description"> 
              continue reading </Link>
            </p>
          </SectionHeaderLayout>

          <Media query="(max-width: 767px)">
            { (matches) => (
                matches ? (
                  <div className="descriptionImages">
                    <Image className="descriptionImage noMargin" src={roundedimage1} circular bordered />
                  </div>
                ) : (
                  <div className="descriptionImages">
                    <Image className="descriptionImage" src={roundedimage1} circular bordered />
                    <Image className="descriptionImage" src={roundedimage2} circular bordered />
                  </div>
                )
            )}
          </Media>

        </Grid.Column>    
    </BasicSectionLayout>
  );
}

export default ThirdSection;

